/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-24T09:40:19.572
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-khmdatachangesapply-'

export default 
{
path: '/rentmanage/khmdatachangesapply',
name: 'rentmanage-khmdatachangesapply',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}khmdatachangesapply-index',

meta:{
...meta,
title: '数据变更申请'
},

component: () => import('@/pages/rentmanage/khmdatachangesapply/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}khmdatachangesapply-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '数据变更申请编辑'
},

component: () => import('@/pages/rentmanage/khmdatachangesapply/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}khmdatachangesapplydetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '数据变更申请新增'
},

component: () => import('@/pages/rentmanage/khmdatachangesapply/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}khmdatachangesapplyView',
auth: [
'hidden'
],

meta:{
...meta,
title: '数据变更申请详情查看'
},

component: () => import('@/pages/rentmanage/khmdatachangesapply/detail-view') ,
},
]
};
